import { createSlotRecipe } from './runtime';

const dialogConfig = {"name":"dialog","slots":["overlay","content","inner","header","body","footer","closeTrigger"],"defaultVariants":{"size":"md"},"variantMap":{"centered":["true"],"size":["xs","sm","md","lg","xl","2xl","3xl","4xl","5xl","6xl","full"]}}

export const dialog = /* @__PURE__ */ createSlotRecipe(dialogConfig)